<template>
  <UiSelect
    v-if="isShowed"
    :model-value="locale"
    class="topbar-language topbar__select"
    item-id="code"
    item-text="name"
    :options="availableLanguages"
    custom-options
    input-fit-width
    @update:model-value="handleSelect"
  >
    <UiSelectOption
      v-for="(language, i) in availableLanguages"
      :key="language.code"
      :option="language"
      class="topbar-language__option"
    >
      <a
        :key="i"
        class="flex w-full items-center"
        :href="getLangUrl(language.code)"
      >
        <span class="mr-2 text-xs uppercase leading-none">
          {{ language.name }}
        </span>
      </a>
    </UiSelectOption>
  </UiSelect>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLanguages } from '~/composables';
import UiSelect from '~/components/ui/UiSelect.vue';
import UiSelectOption from '~/components/ui/UiSelectOption.vue';

const { locale, locales, setLocale } = useI18n();
const { languages } = useLanguages();

const envLocalesSet = new Set<string>(
  locales.value.map((item) => (typeof item === 'string' ? item : item.code)),
);

const availableLanguages = computed(() => {
  return languages.value.filter(
    (language: { code: string; default: boolean; name: string }) =>
      envLocalesSet.has(language.code),
  );
});

const isShowed = computed(() => availableLanguages.value.length > 1);

const getLangUrl = (lang: string) => `/${lang}`;
const handleSelect = (e: any) => setLocale(e);
</script>

<style lang="scss" scoped>
.topbar-language {
  &__option {
    min-width: 176px;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    font-size: 11px;
    font-weight: 700;
    line-height: 11px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    svg {
      color: #3a5199;
      flex-shrink: 0;
      &:nth-child(1) {
        margin-right: 4px;
        width: 20px;
        height: 20px;
      }
      &:nth-child(2) {
        margin-left: auto;
        width: 16px;
        height: 16px;
      }
    }
  }
  &__icon {
    width: 16px;
    height: 16px;
    border-radius: 9999px;
    flex-shrink: 0;
    margin-right: 8px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
